import { makeStyles } from '@mui/styles';
import { neutral7 } from 'apollo-react/colors';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { equalityFn } from '../../form-designer/utils/form-manager.utils';
import NewControl from '../components/NewControl';
import { REPORT_CONTROL_TYPE } from '../constants/report-designer.constants';
import DynamicControl from '../DynamicControl';
import { getChildrenWithControlType } from '../selectors/report-designer.selectors';
import { isExpressionValue } from '../utils/report-designer.utils';

const useStyles = makeStyles({
  titleContainer: {
    textAlign: 'center',
    padding: '7px 0px',
    border: `1px solid ${neutral7}`,
    borderRadius: 5,
    marginBottom: 7,
  },
  childrenContainer: {
    display: 'flex',
    minHeight: 100,
  },
  columnsAndDataContainer: {
    width: '70%',
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingBottom: 25,
  },
  rowsContainer: {
    width: '30%',
    marginRight: 5,
    borderRight: `2px dashed ${neutral7}`,
    paddingRight: 5,
  },
  columnsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  dataContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  horizontalDivider: {
    borderBottom: `2px dashed ${neutral7}`,
    position: 'relative',
    top: 45,
  },
  addColumnContainer: {
    marginBottom: 8,
    height: 40,
    width: '100%',
  },
  agenda: {
    height: 40,
    marginBottom: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const SSCrossTab = ({ matrixTitle, id }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const childrenWithControlType = useSelector(
    (state) => getChildrenWithControlType(state, { id }),
    equalityFn
  );

  const titleToDisplay = !matrixTitle
    ? translateString('Cross Tab Title')
    : isExpressionValue(matrixTitle)
    ? translateString('Expression')
    : matrixTitle;

  const {
    ssCrossTabRow: crossTabRows = [],
    ssCrossTabColumn: crossTabColumns = [],
    ssCrossTabData: crossTabData = [],
  } = childrenWithControlType;

  const tableAgendaLabel = `${translateString('Rows')} \\ ${translateString('Columns')}`;

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography>{titleToDisplay}</Typography>
      </div>
      <div className={classes.horizontalDivider} />
      <div className={classes.childrenContainer}>
        <div className={classes.rowsContainer}>
          <div className={classes.agenda}>{tableAgendaLabel}</div>
          {crossTabRows.map((id) => (
            <DynamicControl key={id} id={id} />
          ))}
          <NewControl parentId={id} controlType={REPORT_CONTROL_TYPE.CROSS_TAB_ROW} />
        </div>
        <div className={classes.columnsAndDataContainer}>
          <div className={classes.columnsContainer}>
            {!crossTabColumns.length && (
              <div className={classes.addColumnContainer}>
                <NewControl parentId={id} controlType={REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN} />
              </div>
            )}
            {crossTabColumns.map((id) => (
              <DynamicControl key={id} id={id} />
            ))}
          </div>
          <div className={classes.dataContainer}>
            {crossTabData.map((id) => (
              <DynamicControl key={id} id={id} />
            ))}
            <NewControl parentId={id} controlType={REPORT_CONTROL_TYPE.CROSS_TAB_DATA} />
          </div>
        </div>
      </div>
    </>
  );
};

export default SSCrossTab;
